<template>
  <div class="c_table_wrap">
    멤버 업데이트 레이아웃
    <div>
      <button @click="$router.back()" class="mr30">목록</button>
      <button @click="$router.back()" class="mr30">저장</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "MemberWriteUpdateLayout",
  mixins: [],
  components: {
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{

    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{

  },
  watch: {

  },
}
</script>

<style scoped>

</style>